"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _AvatarGroup = _interopRequireDefault(require("@mui/material/AvatarGroup"));
var _Avatar = _interopRequireDefault(require("./Avatar"));
var _List = _interopRequireDefault(require("../List/List"));
var _ListItem = _interopRequireDefault(require("../List/ListItem"));
var _Popper = _interopRequireDefault(require("../Popper/Popper"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _Typography = _interopRequireDefault(require("../Typography/Typography"));
var _EDSContext = require("../EDSContext/EDSContext");
var _classnames = _interopRequireDefault(require("classnames"));
var _tokens = require("../styles/tokens");
var _MoreHorizontal = _interopRequireDefault(require("@ellucian/ds-icons/lib/MoreHorizontal"));
var _excluded = ["classes", "children", "max", "spacing", "edsContext", "size"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  return {
    root: {
      flexDirection: 'initial',
      '& $avatar': {
        boxSizing: 'border-box',
        // important is still required to override the original Avatar styles
        border: "solid " + _tokens.borderWidthThick + " " + theme.palette.grey['100'] + " !important",
        '&:first-child': {
          marginLeft: '0 !important' // required to counteract MUI's adjustment for rendering order
        }
      }
    },

    avatar: {
      backgroundColor: theme.palette.grey['300'],
      fontSize: _tokens.fontSizeHeader3,
      color: theme.palette.grey['600']
    },
    spacingSmall: {},
    spacingCondensed: {},
    paper: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey['400'],
      borderRadius: _tokens.borderRadiusMedium
    },
    popperList: {
      borderRadius: _tokens.borderRadiusMedium
    },
    popperItem: {
      '&:first-child': {
        borderRadius: _tokens.borderRadiusMedium + " " + _tokens.borderRadiusMedium + " 0px 0px"
      },
      '&:last-child': {
        borderRadius: "0px 0px " + _tokens.borderRadiusMedium + " " + _tokens.borderRadiusMedium
      },
      '& $popperItemText': {
        color: theme.palette.action.base,
        textDecoration: 'underline'
      },
      '&:hover': {
        '& $popperItemText': {
          color: theme.palette.action.hover,
          textDecoration: 'underline',
          cursor: 'pointer'
        }
      },
      '&:active': {
        '& $popperItemText': {
          color: theme.palette.grey[100],
          textDecoration: 'underline'
        }
      }
    },
    popperItemAvatar: {
      marginRight: _tokens.spacing20
    },
    noHover: {
      pointerEvents: 'none'
    },
    popperItemText: {}
  };
};
var TERTIARY_COLORS_MAP = ['purple', 'iris', 'fountain', 'meadow', 'kiwi', 'saffron', 'tangerine'];
var getColors = function getColors(children) {
  var availableColors = TERTIARY_COLORS_MAP.slice(0);
  var finalColors = [];
  for (var i = 0; i < children.length; i++) {
    if (availableColors.length === 0) {
      availableColors = TERTIARY_COLORS_MAP.slice(0);
    }
    var num = Math.floor(Math.random() * availableColors.length);
    finalColors.push(availableColors[num]);
    availableColors.splice(num, 1);
  }
  return finalColors;
};
var AvatarGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var classes = props.classes,
    children = props.children,
    max = props.max,
    spacing = props.spacing,
    edsContext = props.edsContext,
    size = props.size,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);

  // custom spacing to add our own spacing strategy
  var spacings = {
    condensed: -30,
    small: -16,
    medium: -8
  };

  // newSpacing is the value of the left/right margins when in LTR/RTL
  var newSpacing = spacing && spacings[spacing] !== undefined ? spacings[spacing] : -spacing;

  // adjust the spacing when the group size is set and one of the spacing presets are used
  if (size && spacings[spacing] !== undefined) {
    // the dimensions for each of the Avatar sizes in rem
    var avatarSizes = {
      default: parseFloat(_tokens.sizingXLarge.replace('rem', '')),
      large: 3.5,
      small: parseFloat(_tokens.sizingMedium.replace('rem', ''))
    };

    // adjusts the spacing proportionately to the size of the avatars
    newSpacing = newSpacing * avatarSizes[size] / avatarSizes['default'];
  }
  newSpacing /= 16; // convert the margin spacing to rem values at 16px to 1 rem to be consistent at larger browser text sizes

  var _useState = (0, _react.useState)(),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(getColors(children)),
    colorList = _useState3[0];
  var classOverrides = {
    root: classes.root,
    avatar: (0, _classnames.default)(classes.avatar, (_classNames = {}, _classNames[classes.spacingSmall] = spacing === 'small', _classNames[classes.spacingCondensed] = spacing === 'condensed', _classNames))
  };
  var colorizedChildren = children.slice(0).map(function (child, i) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      color: colorList[i]
    });
  });

  // Updates the Avatar components with the given set of prop overrides
  var updateAvatar = function updateAvatar(node, overrides) {
    // if this is an avatar, apply the overrides
    if (node && node.type && node.type.muiName === 'Avatar') {
      return /*#__PURE__*/_react.default.cloneElement(node, overrides);

      // delve through the children, looking for an Avatar
    } else if (node.props && node.props.children) {
      var clonedChildren = _react.default.Children.map(node.props.children, function (c) {
        return updateAvatar(c, overrides);
      });
      return /*#__PURE__*/_react.default.cloneElement(node, undefined, clonedChildren.length === 1 ? clonedChildren[0] : clonedChildren);

      // we're at a non-Avatar leaf node; return
    } else {
      return node;
    }
  };

  // adds keys, spacing style and size to all of the group children
  // for condensed groups, modify the individual avatars to render them inert
  var groupChildren = colorizedChildren.slice(0, max).map(function (child, i) {
    // override the size prop of the group children
    var updatedAvatar = child;
    if (size) {
      updatedAvatar = updateAvatar(updatedAvatar, {
        size: size
      });
    }
    if (spacing === 'condensed') {
      //set elements in the condensed avatar group to be non-interactive
      updatedAvatar = updateAvatar(updatedAvatar, {
        component: 'div',
        variant: 'default',
        className: (0, _classnames.default)(child.props.className, classes.noHover),
        // render the avatars inert by swallowing any click events; in condensed
        // view, all avatar interaction will be via the popup menu
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();
        }
      });
    }
    return /*#__PURE__*/_react.default.cloneElement(updatedAvatar, {
      key: "Group_Avatar_" + i,
      style: {
        // overrides MUI's inline styles to ensure RTL compatibility
        marginLeft: edsContext.dir === 'ltr' ? newSpacing + "rem" : undefined,
        marginRight: edsContext.dir === 'ltr' ? undefined : newSpacing + "rem"
      }
    });
  });
  var popperChildren = spacing === 'condensed' ? colorizedChildren.slice(0).map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      size: 'small',
      tabIndex: '-1'
    });
  }) : colorizedChildren.slice(max, colorizedChildren.length).map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      size: 'small',
      tabIndex: '-1'
    });
  });
  var handleClick = function handleClick(event) {
    var currentTarget = event.currentTarget;
    setAnchorEl(currentTarget);
    setOpen(!open);
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };

  //synthetically clicks avatar on list item click
  var handleListItemClick = function handleListItemClick(e) {
    var listItem = e.currentTarget;
    listItem.querySelector('.liClickTarget').children[0].click();
  };

  // find the avatar in the DOM tree rooted at the given child; if none is
  // found, returns undefined
  var findAvatar = function findAvatar(node) {
    if (node && node.type && node.type.muiName === 'Avatar') {
      return node;
    } else if (node.props && node.props.children) {
      var ac = _react.default.Children.toArray(node.props.children);
      for (var i = 0; i < ac.length; i++) {
        var avatar = findAvatar(ac[i]);
        if (avatar !== undefined) {
          return avatar;
        }
      }
    } else {
      return undefined;
    }
  };

  // returns true if the given node is (or contains) an interactive avatar
  var isInteractiveAvatar = function isInteractiveAvatar(node) {
    var testChild = findAvatar(node);
    return testChild !== undefined && testChild.props.variant === 'interactive';
  };

  //add terminal avatar
  if (colorizedChildren.length > max) {
    groupChildren.push( /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      key: "Terminal_Group_Avatar",
      title: edsContext.formatMessage('component.AvatarGroup.openMenu')
    }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
      variant: 'interactive',
      onClick: handleClick,
      style: {
        // overrides MUI's inline styles to ensure RTL compatibility
        marginLeft: edsContext.dir === 'ltr' ? newSpacing + "rem" : undefined,
        marginRight: edsContext.dir === 'ltr' ? undefined : newSpacing + "rem"
      },
      size: size
    }, spacing === 'condensed' ? /*#__PURE__*/_react.default.createElement(_MoreHorizontal.default, null) : '+' + popperChildren.length)));
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AvatarGroup.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref,
    max: 50,
    spacing: newSpacing
  }), groupChildren.reverse()), /*#__PURE__*/_react.default.createElement(_Popper.default, {
    role: "alertdialog",
    open: open,
    anchorEl: anchorEl,
    placement: edsContext.dir === 'rtl' ? 'left-start' : 'right-start',
    arrow: true,
    onClickAway: handleClose,
    disablePortal: true,
    PaperProps: {
      classes: {
        root: classes.paper
      }
    },
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 0]
      }
    }]
  }, /*#__PURE__*/_react.default.createElement(_List.default, {
    className: classes.popperList
  }, popperChildren.map(function (child, i) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      key: "Popper_Avatar_" + i,
      button: isInteractiveAvatar(child),
      "aria-label": child.props.alt ? child.props.alt : child.props.title,
      onClick: handleListItemClick,
      className: classes.popperItem
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.popperItemAvatar, 'liClickTarget')
    }, child), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: child.props.onClick ? classes.popperItemText : null
    }, child.props.alt ? child.props.alt : child.props.title));
  }))));
});
AvatarGroup.muiName = 'AvatarGroup';
AvatarGroup.displayName = 'AvatarGroup';
AvatarGroup.propTypes = {
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * The avatars to stack.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * Max avatars to show before "+x" is shown.
   * Value should be greater than or equal to two.
  */
  max: _propTypes.default.number,
  /**
   * The size of the avatars and terminal avatar in the group. Overrides the `size` prop of child avatars.
   */
  size: _propTypes.default.oneOf(['small', 'default', 'large']),
  /**
   * Spacing between avatars.
   *
   * Valid values:
   *
   * * "medium": Default spacing
   * * "small": Closely-spaced avatars
   * * "condensed": Avatars are stacked, one on top of the other. In this mode, a popup shows all available avatars.
   * * `number`: Custom spacing value. Positive values decrease the space between avatars; negative values increase it.
   */
  spacing: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['medium', 'small', 'condensed'])]),
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
AvatarGroup.defaultProps = {
  spacing: 'medium',
  max: 4
};
var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(AvatarGroup));
exports.default = _default;